const specialLanguages = [
    'amharic',
    'albanian',
    'japanese',
    'gujarati',
    'arabic',
    'chinese',
    'hebrew',
    'greek',
    'hindi',
    'tamil',
    'georgian',
    'burmese',
    'persian',
    'urdu',
];

export default specialLanguages;
